module.exports = __webpack_public_path__ + "img/lock_options2.56268aae.svg";